<div
  role="button"
  tabindex="0"
  class="cursor-pointer flex flex-col rounded-2xl font-title px-5 py-4 border border-gray-200 w-full text-left hover:ring-gray-300 active:scale-[0.98] transition bg-white"
>
  <div class="flex items-center justify-between gap-2 w-full">

    <!-- Nom + Estat -->
    <div class="flex items-center gap-2 min-w-0">

      <lib-icon [name]="iconStateName()" />

      <div class="flex flex-col min-w-0 gap-1">

        <!-- Nombre -->
        <span class="font-semibold text-gray-800 overflow-hidden line-clamp-2 leading-5">
          {{ sector().name }}
        </span>

        <!-- Descripció -->
        @if(editMode()){
          <input
            #inputEl
            type="text"
            maxlength="50"
            class="text-gray-400 text-sm bg-transparent rounded-md px-2 py-0.5 ring-1 ring-gray-300 focus:ring-2 focus:ring-brand-400 focus:outline-none min-w-0 w-44"
            [value]="sector().description ?? ''"
            (input)="descriptionChange.emit(inputEl.value)"
            (click)="$event.stopPropagation()"
          />
        } @else if(sector().description) {
          <span class="text-gray-400 text-sm overflow-hidden text-ellipsis whitespace-nowrap">
            {{ sector().description }}
          </span>
        }

        <!-- Mode -->
        <span class="text-gray-500 overflow-hidden text-ellipsis whitespace-nowrap">
          {{ sectorModeString() }}
        </span>

      </div>

    </div>


    <!-- Caudal -->
    @if(showFlowInfo()){
    <div class="px-5 py-2 rounded-xl border border-gray-100 min-w-[120px] max-w-40 shrink-0">
      <div class="flex flex-col gap-1">
        <div class="text-gray-500 text-sm leading-5 truncate">Caudal</div>
        <div class="text-gray-800 font-semibold leading-6 truncate">
          {{ sector().flow?? "-" }}
        </div>
      </div>
    </div>
    }@else{
      <div class="flex items-center justify-center">
        <lib-button variant="outline" size="sm" startIcon="play" iconClass="h-5 w-5" (btnClick)="openManualActionsModal()"
        class="aspect-square w-10 p-0 flex items-center justify-center">
        </lib-button>   
      </div>
    }
  </div>
  
  @if(sector().stateReason !== SectorStateReason.NONE){
    <lib-sector-state-reason-badge [sector]="sector()" class="mt-1"></lib-sector-state-reason-badge>
  }

  @if(sector().schedulingPerson){
    <div
      class="mt-1 w-fit flex items-center gap-1 px-2.5 py-1 rounded-full text-gray-700 text-xs font-title font-medium"
      [class.bg-brand-50]="sector().schedulingPersonType === 'OWNER'"
      [class.bg-gray-100]="sector().schedulingPersonType !== 'OWNER'">
      <lib-icon [name]="schedulingPersonIcon()" class="size-4 flex-shrink-0 overflow-hidden [&>span]:!size-4"></lib-icon>
      <span class="truncate">{{ sector().schedulingPerson }}</span>
    </div>
  }

</div>
